/* eslint-disable eqeqeq */
import * as React from 'react';
import { useLatest } from "./useLatest";

var useTimeout = function useTimeout(callback, delay) {
  var callbackRef = useLatest(callback);
  React.useEffect(function () {
    var tick = function tick() {
      callbackRef.current();
    };

    if (delay != null) {
      var id = setTimeout(tick, delay);
      return function () {
        return clearTimeout(id);
      };
    }
  }, [delay, callbackRef]);
};

export default useTimeout;